import {history} from 'instantsearch.js/es/lib/routers';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import components from '../algolia';

const loadLiterature = () => {
  if (document.querySelector('.literature')) {
    new Vue({
      el: '.literature',
      comments: true,
      components,
      data() {
        const indexName = this.$algolia.indexPrefix + 'literature';

        const routing = {
          router: history(),
          stateMapping: {
            stateToRoute(uiState) {
              const indexUiState = uiState[indexName] || {};
              return {
                query: indexUiState.query,
                product_type: indexUiState.menu?.product_type
              };
            },
            routeToState(routeState) {
              return {
                [indexName]: {
                  query: routeState.query,
                  menu: {
                    product_type: routeState.product_type
                  }
                }
              };
            }
          }
        };

        return {
          indexName,
          routing
        };
      },
      methods: {
        getFileTranslations(item) {
          if (Object.prototype.hasOwnProperty.call(item, 'file_translations')) {
            return JSON.parse(item.file_translations);
          }

          return [{'en': item.file}];
        }
      },
      router
    });
  }
};

export default loadLiterature;
